import {LayerDef} from "./LayerDef";
import {Hill} from "./Hill";
import {HillLists, LayerDefBase} from "./LayerDefBase";
import {Style} from "ol/style";
import {COLOURS} from "./Colours";

export class SimmLayerDef extends LayerDefBase implements LayerDef {
    private visitedStyle = LayerDefBase.buildStyle(5, COLOURS.SIMM.VISITED);
    private unvisitedStyle = LayerDefBase.buildStyle(5, COLOURS.SIMM.UNVISITED);

    isVisible(): boolean {
        return false;
    }

    protected getUnvisitedStyle(): Style {
        return this.unvisitedStyle;
    }

    protected getVisitedStyle(): Style {
        return this.visitedStyle;
    }

    protected getLayerHills(hillLists: HillLists): Hill[] {
        const combined = [
            ...hillLists.others,
            ...this.removeWainwrights(hillLists.lakes),
        ];
        return combined
            .filter((h) => h.categories.includes("SIMM"))
            .filter((h) => !h.categories.includes("MARILYN"))
            .filter((h) => !h.categories.includes("HUMP"));
    }

    setupGPX() {
        const elem = document.getElementById("gpx_simm");
        this.setGPXClickListener(elem, "simms.gpx");
    }

    getName(): string {
        return "Simms";
    }
}
